// components/Sidebar.js
import React, { useState } from 'react';
import InstallAppMenuItem from '../components/InstallAppMenuItem';

function Sidebar({ p_roles, onClose, onLogout, p_sharedLists, p_isProprio, onOpenSharedList, onRemoveSharedList }) {
  console.log("Sidebar roles:", p_roles);
  const [isSharedOpen, setIsSharedOpen] = useState(false);
  const [openOwners, setOpenOwners] = useState({});
  const groupedSharedLists = (p_sharedLists || []).reduce((acc, entry) => {
    const ownerLabel = entry.ownerName || entry.ownerKey || "Proprietaire";
    if (!acc[ownerLabel]) acc[ownerLabel] = [];
    acc[ownerLabel].push(entry);
    return acc;
  }, {});
  return (
    <div className="ui-overlay" onClick={onClose}>
      <div className="kdo-sidebar" onClick={(e) => e.stopPropagation()}>
        <button className="kdo-sidebar-close" onClick={onClose}>×</button>
        <h3>Menu</h3>
        <InstallAppMenuItem />
        {/* <p>
          <a href="/preferences">Preferences</a>
        </p> */}
        <p>
          <a href="https://listaki.fr/aide" target="_blank" rel="noopener noreferrer">Aide</a>
        </p>
        <p>
          <a href="https://listaki.fr/changelog" target="_blank" rel="noopener noreferrer">Nouveautés</a>
        </p>
        {p_isProprio && p_sharedLists && p_sharedLists.length > 0 && (
          <>
            <p>----</p>
            <button
              type="button"
              className="kdo-button-like-link"
              onClick={() => setIsSharedOpen((prev) => !prev)}
            >
              {isSharedOpen ? "- Listes memorisées" : "+ Listes memorisées"}
            </button>
            {isSharedOpen && (
              <div className="kdo-sidebar-shared">
                {Object.entries(groupedSharedLists).map(([ownerLabel, entries]) => {
                  const isOwnerOpen = Boolean(openOwners[ownerLabel]);
                  return (
                    <div className="kdo-sidebar-shared-group" key={ownerLabel}>
                      <button
                        type="button"
                        className="kdo-button-like-link kdo-sidebar-shared-owner-toggle"
                        onClick={() =>
                          setOpenOwners((prev) => ({
                            ...prev,
                            [ownerLabel]: !isOwnerOpen
                          }))
                        }
                      >
                        {isOwnerOpen ? `- ${ownerLabel}` : `+ ${ownerLabel}`}
                      </button>
                      {isOwnerOpen && entries.map((entry) => (
                        <div className="kdo-sidebar-shared-item" key={`${entry.key}-${entry.idList}`}>
                          <button
                            className="kdo-sidebar-shared-link"
                            onClick={() => onOpenSharedList && onOpenSharedList(entry)}
                          >
                            {entry.name || `Liste ${entry.idList}`}
                          </button>
                          <button
                            className="kdo-sidebar-shared-remove"
                            onClick={() => onRemoveSharedList && onRemoveSharedList(entry)}
                            title="Supprimer de mes listes mémorisées"
                          >
                            X
                          </button>
                        </div>
                      ))}
                    </div>
                  );
                })}
              </div>
            )}
          </>
        )}
        <p>----</p>
        <p>
          <button onClick={onLogout} className="kdo-button-like-link">
            Se déconnecter
          </button>
        </p>
                {p_roles && p_roles.includes('ADMIN') && (
          <>
          <p>--ADMIN--</p>
          <p>
            <a href="/stats">Statistiques</a>
          </p>
          <p>
            <a href="/report">Rapport détaillé</a>
          </p>
          </>
        )}
      </div>
    </div>
  );
}

export default Sidebar;
